import { jsx as e, jsxs as m } from "react/jsx-runtime";
import g from "classnames";
import { kebabCase as oe } from "lodash";
import Q, { forwardRef as le, useCallback as X, useMemo as Y, cloneElement as M } from "react";
import { MULTI_TO_COMPONENT as fe } from "./index.es5535.js";
import { useFocusFirstItemWhenAutoFocus as pe } from "./index.es5533.js";
import { mergeTooltipPropsForSmartTooltip as de } from "./index.es5534.js";
import { tooltipIconPropsConvertor as he } from "./index.es5536.js";
import t from "./index.es5537.js";
import { useTheme as ue } from "./index.es190.js";
import { ColorIndicator as ce } from "./index.es32.js";
import { Thumbnail as ve } from "./index.es126.js";
import { Divider as Z } from "./index.es24.js";
import { TooltipIcon as Ne } from "./index.es162.js";
import { getAriaAttributes as xe } from "./index.es531.js";
import { mergeRefs as K } from "./index.es551.js";
import { Skeleton as y } from "./index.es71.js";
import { SmartTooltipWrapper as ge } from "./index.es525.js";
import { getDisabledAria as be } from "./index.es530.js";
import { BodyText as k } from "./index.es505.js";
import { Icon as Te } from "./index.es157.js";
import { onKeyDownEnterAndSpace as Ce } from "./index.es526.js";
const Xe = le(
  ({
    Icon: p,
    Badge: S,
    description: d,
    label: h,
    entityColor: l,
    hasDivider: E,
    isSelected: i,
    isDisabled: a,
    isLocked: f,
    colorIndicator: u,
    colorIndicatorProps: r,
    RightIcon: F,
    testId: O,
    tooltipIconProps: P,
    labelInfo: L,
    wrapperStyle: A,
    thumbnail: c,
    tooltip: z,
    lockedTooltip: D,
    // Add support for lockedTooltip
    multi: v,
    autoFocus: ee = !1,
    onClick: b,
    onKeyDown: T,
    onLockedClick: C,
    isLoading: o = !1,
    role: N = "menuitem",
    highLightText: _,
    ...w
  }, R) => {
    const te = Q.useRef(null), V = ue(), [ae, W] = Q.useState(!1), s = `${O ? `${oe(O)}-` : ""}multiline-item`, j = g(t.container, {
      [t.containerWithEntity]: !!l
    }), B = g(t.root, {
      [t.disabled]: a
    }), H = g(t.textContent, {
      [t.noLeftIcon]: !p
    }), ne = g(t.icon, {
      [t.hasThumbnail]: c,
      [t.hasEntity]: l,
      [t.oneLineDescription]: !String(d).includes(`
`)
    }), { refForFirstItem: I } = pe(ee), U = X(() => {
      W(!0);
    }, []), q = X(() => {
      W(!1);
    }, []), ie = (n) => {
      T == null || T(n), Ce(n, G, !1);
    }, G = (n) => {
      a || (f ? C == null || C(n) : b == null || b(n));
    }, J = he({
      tooltipIconProps: P,
      labelInfo: L
    }), re = Y(() => N ? xe(N, !!i) : {}, [N, i]), me = de({ tooltip: z, lockedTooltip: D }), se = Y(() => {
      let n;
      if (l || r || u) {
        const x = l || (r == null ? void 0 : r.entityColor) || u;
        n = /* @__PURE__ */ e(
          ce,
          {
            color: u,
            thickness: "thick",
            entityColor: l,
            disabled: a,
            testId: (r == null ? void 0 : r.testId) || `${s}-color-indicator-${x}`,
            ...r
          }
        );
      }
      if (p && (n = M(p, {
        color: a ? "outline" : "blue",
        outline: a ? "disabled" : "default-gray"
      })), c) {
        const x = /* @__PURE__ */ e(
          ve,
          {
            size: "medium",
            disabled: a,
            testId: `${s}-thumbnail`,
            ...c
          }
        );
        v ? n = x : n = /* @__PURE__ */ e("div", { className: t.thumbnailContainer, children: x });
      }
      return v ? /* @__PURE__ */ m("div", { className: t.thumbnailContainer, children: [
        M(fe[v], {
          checked: i,
          disabled: a,
          onCheckedChange: void 0
        }),
        n
      ] }) : n;
    }, [
      p,
      u,
      r,
      l,
      a,
      i,
      v,
      s,
      c
    ]);
    if (o)
      return /* @__PURE__ */ m(
        "div",
        {
          className: B,
          ref: K(I, R),
          "data-testid": s,
          style: A,
          ...w,
          children: [
            /* @__PURE__ */ m("div", { className: j, children: [
              /* @__PURE__ */ e(
                y,
                {
                  isVisible: o,
                  height: "18px",
                  width: "18px",
                  margin: `${V.spacings.xl} 0 0 0`,
                  "aria-label": "skeleton loading for icon"
                }
              ),
              /* @__PURE__ */ m("div", { className: H, children: [
                /* @__PURE__ */ e("span", { className: t.topText, children: /* @__PURE__ */ e(
                  y,
                  {
                    isVisible: o,
                    height: "16px",
                    width: "calc(20%)",
                    margin: `0 0 ${V.spacings.s} 0`,
                    "aria-label": "skeleton loading for item label"
                  }
                ) }),
                /* @__PURE__ */ e("span", { className: t.topText, children: /* @__PURE__ */ e(
                  y,
                  {
                    isVisible: o,
                    height: "16px",
                    width: "100%",
                    "aria-label": "skeleton loading for item description"
                  }
                ) })
              ] })
            ] }),
            /* @__PURE__ */ e(Z, { visible: E, margin: "0 12px" })
          ]
        }
      );
    let $ = "gray";
    return a ? $ = "disabled" : (i || ae) && ($ = "primary"), /* @__PURE__ */ e(
      ge,
      {
        tooltip: me,
        isLocked: f,
        itemLabel: h,
        isDisabled: a,
        isOverflowing: !1,
        testId: `${s}-tooltip`,
        children: /* @__PURE__ */ m(
          "div",
          {
            ref: K(I, R),
            "aria-label": `${h} ${d}`,
            "aria-labelledby": `${h} ${d}`,
            "aria-details": f ? "Menu Item in locked state" : void 0,
            role: N,
            className: B,
            "data-testid": s,
            style: A,
            onKeyDown: o ? void 0 : ie,
            "data-selected": i,
            onClick: o ? void 0 : G,
            onMouseEnter: U,
            onFocus: U,
            onMouseLeave: q,
            onBlur: q,
            ...be(!!a, !!z, "none"),
            ...re,
            ...w,
            children: [
              /* @__PURE__ */ m("div", { ref: te, className: j, children: [
                /* @__PURE__ */ e("span", { className: ne, children: se }),
                /* @__PURE__ */ m("div", { className: H, children: [
                  /* @__PURE__ */ m("span", { className: t.topText, children: [
                    /* @__PURE__ */ e(
                      k,
                      {
                        size: "default",
                        isEllipsis: !0,
                        variant: i ? "bold" : "semi-bold",
                        element: "span",
                        color: a ? "disabled" : "primary",
                        "data-testid": `${s}-label`,
                        highlightText: i ? void 0 : _,
                        children: h
                      }
                    ),
                    !o && J && /* @__PURE__ */ e(Ne, { ...J })
                  ] }),
                  /* @__PURE__ */ m("span", { className: t.topText, children: [
                    /* @__PURE__ */ e(
                      k,
                      {
                        size: "small",
                        variant: "regular",
                        element: "p",
                        color: $,
                        "data-testid": `${s}-description`,
                        clamp: 2,
                        highlightText: i ? void 0 : _,
                        children: d ?? ""
                      }
                    ),
                    S
                  ] })
                ] }),
                (f || F) && /* @__PURE__ */ e("span", { className: t.icon, children: f ? /* @__PURE__ */ e(Te, { size: 16, type: "Lock" }) : M(F, {
                  color: "outline",
                  outline: a ? "disabled" : "default-gray",
                  tabIndex: a ? -1 : 0
                }) })
              ] }),
              /* @__PURE__ */ e(Z, { visible: E, margin: "0 12px" })
            ]
          }
        )
      }
    );
  }
);
export {
  Xe as MultilineItem
};
//# sourceMappingURL=index.es85.js.map
